/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LaboratoryRoomDataDTO
 */
export interface LaboratoryRoomDataDTO {
    /**
     * 
     * @type {string}
     * @memberof LaboratoryRoomDataDTO
     */
    type?: string | null;
    /**
     * 
     * @type {number}
     * @memberof LaboratoryRoomDataDTO
     */
    no?: number;
    /**
     * 
     * @type {string}
     * @memberof LaboratoryRoomDataDTO
     */
    roomNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LaboratoryRoomDataDTO
     */
    roomName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof LaboratoryRoomDataDTO
     */
    area?: number;
    /**
     * 
     * @type {number}
     * @memberof LaboratoryRoomDataDTO
     */
    capacity?: number;
    /**
     * 
     * @type {number}
     * @memberof LaboratoryRoomDataDTO
     */
    ratio?: number;
}

export function LaboratoryRoomDataDTOFromJSON(json: any): LaboratoryRoomDataDTO {
    return LaboratoryRoomDataDTOFromJSONTyped(json, false);
}

export function LaboratoryRoomDataDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): LaboratoryRoomDataDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': !exists(json, 'type') ? undefined : json['type'],
        'no': !exists(json, 'no') ? undefined : json['no'],
        'roomNumber': !exists(json, 'roomNumber') ? undefined : json['roomNumber'],
        'roomName': !exists(json, 'roomName') ? undefined : json['roomName'],
        'area': !exists(json, 'area') ? undefined : json['area'],
        'capacity': !exists(json, 'capacity') ? undefined : json['capacity'],
        'ratio': !exists(json, 'ratio') ? undefined : json['ratio'],
    };
}

export function LaboratoryRoomDataDTOToJSON(value?: LaboratoryRoomDataDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'no': value.no,
        'roomNumber': value.roomNumber,
        'roomName': value.roomName,
        'area': value.area,
        'capacity': value.capacity,
        'ratio': value.ratio,
    };
}

